module.exports = __webpack_public_path__ + "static/media/bij_de_fontein.735ee502.png";